/**
 * @generated SignedSource<<31cfe2af2938b091eade2c4eb986a734>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeBenefitsFaq_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsFaqSidebar_viewer">;
  readonly " $fragmentType": "TradeBenefitsFaq_viewer";
};
export type TradeBenefitsFaq_viewer$key = {
  readonly " $data"?: TradeBenefitsFaq_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsFaq_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeBenefitsFaq_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TradeBenefitsFaqSidebar_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "48d9727e8dca8800f47f451a21474b87";

export default node;
